import styled from 'styled-components';

export default styled.div`
    margin-top: var(--px-20);
    padding: 0 0 0 var(--px-20);
	max-height: var(--px-380);
	.components{
		margin-bottom: var(--px-12);
	}
`;